export function normalizeApiBase(raw) {
  return String(raw ?? "").replace(/['"]/g, "").trim();
}

export function isDevApiBase(apiBase) {
  return /dev\.lip-sync\.ai/i.test(normalizeApiBase(apiBase));
}

export function isLocalPreviewHost(hostname) {
  const host = String(hostname || "").toLowerCase();
  return (
    host === "localhost" ||
    host === "0.0.0.0" ||
    host === "::1" ||
    host === "[::1]" ||
    host.startsWith("127.") ||
    host.endsWith(".local")
  );
}

export function isLocalPreviewRuntime() {
  return import.meta.client && isLocalPreviewHost(window.location.hostname);
}

export function resolveGaEnabled(env = process.env) {
  const explicit = env.NUXT_PUBLIC_GA_ENABLED?.trim().toLowerCase();
  if (explicit === "false") return false;
  if (explicit === "true") return true;
  if (isDevApiBase(env.NUXT_PUBLIC_API_BASE)) return false;
  if (env.NODE_ENV !== "production") return false;
  return true;
}

export function resolveLogstoreEnabled(env = process.env) {
  const explicit = env.NUXT_PUBLIC_LOGSTORE_ENABLED?.trim().toLowerCase();
  if (explicit === "false") return false;
  return true;
}

/** @deprecated Use resolveLogstoreEnabled instead. */
export function resolveAnalyticsEnabled(env = process.env) {
  return resolveLogstoreEnabled(env);
}

export function isGaEnabled(config) {
  // 显式关闭
  if (config?.public?.gaEnabled === false) return false;
  // 显式开启：测试站 / 本地可用 NUXT_PUBLIC_GA_ENABLED=true 验收（会打到同一 Measurement ID）
  if (config?.public?.gaEnabled === true) return true;
  // 默认：仅生产域名开启；本地 / nuxt dev / dev.lip-sync.ai 关闭
  if (import.meta.dev) return false;
  if (isLocalPreviewRuntime()) return false;
  if (import.meta.client && /dev\.lip-sync\.ai/i.test(window.location.hostname)) {
    return false;
  }
  return true;
}

export function isLogstoreEnabled(config) {
  return config?.public?.logstoreEnabled !== false;
}

export function isAnalyticsEnabled(config) {
  return isLogstoreEnabled(config);
}
